import { render, staticRenderFns } from "./addsection.vue?vue&type=template&id=638cb655&scoped=true&"
import script from "./addsection.vue?vue&type=script&lang=js&"
export * from "./addsection.vue?vue&type=script&lang=js&"
import style0 from "./addsection.vue?vue&type=style&index=0&id=638cb655&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638cb655",
  null
  
)

export default component.exports